import Vue from "vue";
import Router from "vue-router";
import Components from "./pages/Components.vue";
import MainNavbar from "./layout/MainNavbar.vue";
import MainFooter from "./layout/MainFooter.vue";

/*
  secciones cms
*/
import PasswordChange from "./pages/cms/PasswordChange.vue";
import Contacto from "./pages/cms/Contacto.vue";
import Tramites from "./pages/cms/Tramites.vue";
import CentroMedicoEcuador from "./pages/cms/CentroMedicoEcuador.vue";
import Faq from "./pages/cms/Faq.vue";
import Login from "./pages/cms/Login.vue";
import LoginPrestador from "./pages/cms/LoginPrestador.vue";
import Register from "./pages/cms/Register.vue";
import Reset from "./pages/cms/Reset.vue";
import ResetPrestador from "./pages/cms/ResetPrestador.vue";
import QuieroAfiliarme from "./pages/cms/QuieroAfiliarme.vue";
import QuienesSomos from "./pages/cms/QuienesSomos.vue";
import Oficinas from "./pages/cms/Oficinas.vue";
import TelefonosUtiles from "./pages/cms/TelefonosUtiles.vue";
import Formularios from "./pages/cms/Formularios.vue";
import FormulariosAfiliacion from "./pages/cms/FormulariosAfiliacion.vue";
import FormulariosPrestador from "./pages/cms/FormulariosPrestador.vue";
import Post from "./pages/cms/Post.vue";
import CartillaPrestadores from "./pages/cms/CartillaPrestadores.vue";
import Noticias from "./pages/cms/Noticias.vue";
import Noticia1 from "./pages/cms/Noticia1.vue";
import Noticia2 from "./pages/cms/Noticia2.vue";
import Noticia3 from "./pages/cms/Noticia3.vue";
import Noticia4 from "./pages/cms/Noticia4.vue";
import Template2 from "./pages/cms/Templates/Template2.vue";
import Normativa from "./pages/cms/Templates/Normativa.vue";
import Home from "./pages/cms/Home.vue";
//import HomeV1 from "./pages/cms/HomeV1.vue";
//import HomeV2 from "./pages/cms/HomeV2.vue";
//import HomeV3 from "./pages/cms/HomeV3.vue";
import HomeV4 from "./pages/cms/HomeV4.vue";
import Planes from "./pages/cms/Planes.vue";

Vue.use(Router);

const menuCms = [{
    path: "/password/change",
    name: "passwordChange",
    components: {
      default: PasswordChange,
      header: MainNavbar,
      footer: MainFooter
    },
    props: {
      footer: {
        backgroundColor: "black"
      }
    }
  },
  {
    path: "/contacto",
    name: "contacto",
    components: {
      default: Contacto,
      header: MainNavbar,
      footer: MainFooter
    },
    props: {
      footer: {
        backgroundColor: "black"
      }
    }
  },
  {
    path: "/login",
    name: "login",
    components: {
      default: Login,
      header: MainNavbar,
      footer: MainFooter
    },
    props: {
      footer: {
        backgroundColor: "black"
      }
    }
  },
  {
    path: "/register",
    name: "register",
    components: {
      default: Register,
      header: MainNavbar,
      footer: MainFooter
    },
    props: {
      footer: {
        backgroundColor: "black"
      }
    }
  },
  {
    path: "/reset",
    name: "reset",
    components: {
      default: Reset,
      header: MainNavbar,
      footer: MainFooter
    },
    props: {
      footer: {
        backgroundColor: "black"
      }
    }
  },
  {
    path: "/prestador/reset",
    name: "resetPrestador",
    components: {
      default: ResetPrestador,
      header: MainNavbar,
      footer: MainFooter
    },
    props: {
      footer: {
        backgroundColor: "black"
      }
    }
  },
  {
    path: "/prestador/login",
    name: "loginPrestador",
    components: {
      default: LoginPrestador,
      header: MainNavbar,
      footer: MainFooter
    },
    props: {
      footer: {
        backgroundColor: "black"
      }
    }
  },
  {
    path: "/afiliarme",
    name: "afiliarme",
    components: {
      default: QuieroAfiliarme,
      header: MainNavbar,
      footer: MainFooter
    },
    props: {
      footer: {
        backgroundColor: "black"
      }
    }
  },
  {
    path: "/oficinas",
    name: "oficinas",
    components: {
      default: Oficinas,
      header: MainNavbar,
      footer: MainFooter
    },
    props: {
      footer: {
        backgroundColor: "black"
      }
    }
  },
  {
    path: "/telefonos",
    name: "telefonos",
    components: {
      default: TelefonosUtiles,
      header: MainNavbar,
      footer: MainFooter
    },
    props: {
      footer: {
        backgroundColor: "black"
      }
    }
  },
  {
    path: "/formularios",
    name: "formularios",
    components: {
      default: Formularios,
      header: MainNavbar,
      footer: MainFooter
    },
    props: {
      footer: {
        backgroundColor: "black"
      }
    }
  },
  {
    path: "/formulariosAfiliacion",
    name: "formulariosAfiliacion",
    components: {
      default: FormulariosAfiliacion,
      header: MainNavbar,
      footer: MainFooter
    },
    props: {
      footer: {
        backgroundColor: "black"
      }
    }
  },
  {
    path: "/formulariosPrestador",
    name: "formulariosPrestador",
    components: {
      default: FormulariosPrestador,
      header: MainNavbar,
      footer: MainFooter
    },
    props: {
      footer: {
        backgroundColor: "black"
      }
    }
  },
  {
    path: "/institucional",
    name: "institucional",
    components: {
      default: QuienesSomos,
      header: MainNavbar,
      footer: MainFooter
    },
    props: {
      footer: {
        backgroundColor: "black"
      }
    }
  },
  {
    path: "/noticias",
    name: "noticias",
    components: {
      default: Noticias,
      header: MainNavbar,
      footer: MainFooter
    },
    props: {
      footer: {
        backgroundColor: "black"
      }
    }
  },
  {
    path: "/tramites",
    name: "tramites",
    components: {
      default: Tramites,
      header: MainNavbar,
      footer: MainFooter
    },
    props: {
      footer: {
        backgroundColor: "black"
      }
    }
  },
  {
    path: "/centroMedicoEcuador",
    name: "centroMedicoEcuador",
    components: {
      default: CentroMedicoEcuador,
      header: MainNavbar,
      footer: MainFooter
    },
    props: {
      footer: {
        backgroundColor: "black"
      }
    }
  },
  {
    path: "/faq",
    name: "faq",
    components: {
      default: Faq,
      header: MainNavbar,
      footer: MainFooter
    },
    props: {
      footer: {
        backgroundColor: "black"
      }
    }
  },
  {
    path: "/post/:postName",
    name: "post",
    components: {
      default: Post,
      header: MainNavbar,
      footer: MainFooter
    },
    props: {
      footer: {
        backgroundColor: "black"
      }
    }
  },
  {
    path: "/noticia1",
    name: "noticia1",
    components: {
      default: Noticia1,
      header: MainNavbar,
      footer: MainFooter
    },
    props: {
      footer: {
        backgroundColor: "black"
      }
    }
  },
  {
    path: "/noticia2",
    name: "noticia2",
    components: {
      default: Noticia2,
      header: MainNavbar,
      footer: MainFooter
    },
    props: {
      footer: {
        backgroundColor: "black"
      }
    }
  },
  {
    path: "/noticia3",
    name: "noticia3",
    components: {
      default: Noticia3,
      header: MainNavbar,
      footer: MainFooter
    },
    props: {
      footer: {
        backgroundColor: "black"
      }
    }
  },
  {
    path: "/noticia4",
    name: "noticia4",
    components: {
      default: Noticia4,
      header: MainNavbar,
      footer: MainFooter
    },
    props: {
      footer: {
        backgroundColor: "black"
      }
    }
  },
  {
    path: "/cartillaPrestadores",
    name: "cartillaPrestadores",
    components: {
      default: CartillaPrestadores,
      header: MainNavbar,
      footer: MainFooter
    },
    props: {
      footer: {
        backgroundColor: "black"
      }
    }
  },
  {
    path: "/template2/:postName",
    name: "template2",
    components: {
      default: Template2,
      header: MainNavbar,
      footer: MainFooter
    },
    props: {
      footer: {
        backgroundColor: "black"
      }
    }
  },
  {
    path: "/normativa/:postName",
    name: "normativa",
    components: {
      default: Normativa,
      header: MainNavbar,
      footer: MainFooter
    },
    props: {
      footer: {
        backgroundColor: "black"
      }
    }
  },
  {
    path: "/home",
    name: "home",
    components: {
      default: Home,
      header: MainNavbar,
      footer: MainFooter
    },
    props: {
      footer: {
        backgroundColor: "black"
      }
    }
  },/*
  {
    path: "/homeV1",
    name: "homeV1",
    components: {
      default: HomeV1,
      header: MainNavbar,
      footer: MainFooter
    },
    props: {
      footer: {
        backgroundColor: "black"
      }
    }
  },
  {
    path: "/homeV2",
    name: "homeV2",
    components: {
      default: HomeV2,
      header: MainNavbar,
      footer: MainFooter
    },
    props: {
      footer: {
        backgroundColor: "black"
      }
    }
  },
  {
    path: "/homeV3",
    name: "homeV3",
    components: {
      default: HomeV3,
      header: MainNavbar,
      footer: MainFooter
    },
    props: {
      footer: {
        backgroundColor: "black"
      }
    }
  },*/
  {
    path: "/homeV4",
    name: "homeV4",
    components: {
      default: HomeV4,
      header: MainNavbar,
      footer: MainFooter
    },
    props: {
      footer: {
        backgroundColor: "black"
      }
    }
  },
  {
    path: "/planes",
    name: "planes",
    components: {
      default: Planes,
      header: MainNavbar,
      footer: MainFooter
    },
    props: {
      footer: {
        backgroundColor: "black"
      }
    }
  }
];

const router = new Router({
  routes: [{
      path: "/",
      redirect: "/homeV4"
    },
    {
      path: "/components",
      name: "components",
      components: {
        default: Components,
        header: MainNavbar,
        footer: MainFooter
      },
      props: {
        footer: {
          backgroundColor: "black"
        },
        header: {
          colorOnScroll: 65
        }
      }
    },
    ...menuCms
  ],
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return {
        selector: to.hash
      };
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  }
});

export default router;